import React, { useState } from "react";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import classes from "./new.module.css";
import { sendEmailToAdmin } from "../../Network_Calls/new.network";
import ClipLoader from "react-spinners/ClipLoader";

const NewPage = () => {
  const [buttonState, setbuttonState] = useState(false);
  const [buttonMsg, setbuttonMsg] = useState(false);
  const handleButtonClick = async () => {
    setbuttonState(true);
    await sendEmailToAdmin()
      .then((x) => setbuttonMsg(true))
      .catch((e) => console.log(e));
  };

  return (
    <div>
      <Navbar />
      <div className={classes.container}>
        <div className={classes.text}>
          Do you like what you see? Our unique platform allows you to get
          insights about engagement of Customers, Suppliers, Partners and
          Employees in a very intuitive Journey Map. Integrating data from
          variety of systems you can gain 360 degree view of the experience.
          <br />
          <p className={classes.para}>
            Contact us for a free consultation by clicking{" "}
            <button
              onClick={handleButtonClick}
              disabled={buttonState}
              className={classes.btn}
            >
              Contact me
            </button>{" "}
            <span style={{ margin: "0 8px" }}>
              <ClipLoader
                color={"#4CB9E7"}
                loading={buttonState}
                // cssOverride={override}
                size={20}
                aria-label="Loading Spinner"
                data-testid="loader"
              />
            </span>
          </p>
        </div>
        {buttonMsg ? (
          <p className={classes.msg}>
            Our Executive will contact you shortly..
          </p>
        ) : (
          ""
        )}
      </div>
      <Footer />
    </div>
  );
};

export default NewPage;
